import { switchAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers, defineStyle } from "@chakra-ui/react";

import { focusRingInline } from "theme/tokens/accessibility";

const { defineMultiStyleConfig } = createMultiStyleConfigHelpers(
  switchAnatomy.keys,
);

const getColorStyles = (color: string) => ({
  background: color,
  borderColor: color,
});

const baseStyleContainer = defineStyle({
  cursor: "pointer",
  _disabled: {
    cursor: "default",
  },
});

const baseStyleTrack = defineStyle({
  "--switch-bg": "var(--chakra-colors-neutral-emphasized)",
  ...getColorStyles("neutral.emphasized"),
  _checked: {
    "--switch-bg": "var(--chakra-colors-highlight-solid)",
    ...getColorStyles("highlight.solid"),
  },
  _focus: {
    boxShadow: "none",
  },
  _focusVisible: {
    ...focusRingInline,
  },
  _disabled: {
    opacity: 1,
    cursor: "default",
    "--switch-bg": "var(--chakra-colors-neutral-muted)",
    ...getColorStyles("neutral.muted"),
    _checked: {
      "--switch-bg": "var(--chakra-colors-neutral-muted)",
      ...getColorStyles("neutral.muted"),
    },
  },
});

const baseStyleThumb = defineStyle({
  background: "switch.thumb",
  transitionProperty: "transform",
  transitionDuration: (theme) => theme.transition.duration.extraFast,
  transitionTimingFunction: (theme) => theme.transition.easing.easeOut,

  _disabled: {
    bg: "neutral.subtle",
  },
});

export const Switch = defineMultiStyleConfig({
  baseStyle: {
    container: baseStyleContainer,
    track: baseStyleTrack,
    thumb: baseStyleThumb,
  },
});
